import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button } from "@/components/agent/Button";
import CommandsTable from "@/components/agent/CommandsTable";
import SubAgentsTable from "@/components/agent/SubAgentsTable";
import { ScrollArea, ScrollBar } from "@/components/atomic/ScrollArea";
import TitleBar from "@/components/ui/TitleBar";
import { routes } from "@/configs/router.config/routes";
import { cn } from "@/lib/utils";

const AgentManagementPage: React.FC = () => {
  const { workspaceId } = useParams<{ workspaceId: string; }>();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // クエリパラメータからタブを取得、デフォルトは "commands"
  const activeTab = (searchParams.get("tab") as "commands" | "subAgents") || "commands";

  // タブを変更する関数
  const setActiveTab = (tab: "commands" | "subAgents") => {
    setSearchParams({ tab });
  };

  if (!workspaceId) return null;

  return (
    <div className="">
      <TitleBar title="プロンプト管理" />

      <ScrollArea className="h-[calc(100vh-100px)]">
        <div className="p-8 flex flex-col gap-5 w-full max-w-[1320px]">
          {/* Tabs */}
          <div className="">
            <div className="border-b border-gray-200">
              <div className="flex gap-4">
                <button
                  onClick={() => setActiveTab("commands")}
                  className={cn(
                    "px-4 py-2 text-sm font-medium border-b-2 transition-colors",
                    activeTab === "commands"
                      ? "border-[#4c65aa] text-[#4c65aa]"
                      : "border-transparent text-gray-500 hover:text-gray-700",
                  )}
                >
                  プロンプト
                </button>
                <button
                  onClick={() => setActiveTab("subAgents")}
                  className={cn(
                    "px-4 py-2 text-sm font-medium border-b-2 transition-colors",
                    activeTab === "subAgents"
                      ? "border-[#4c65aa] text-[#4c65aa]"
                      : "border-transparent text-gray-500 hover:text-gray-700",
                  )}
                >
                  サブエージェント
                </button>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === "commands" && (
            <div>
              <div className="flex justify-end mb-4">
                <Button
                  onClick={() => navigate(routes.createCommand(workspaceId))}
                  className="bg-[#6888E1] hover:bg-[#6888E1]/90 text-white"
                >
                  新規作成
                </Button>
              </div>
              <CommandsTable />
            </div>
          )}

          {activeTab === "subAgents" && (
            <div>
              <div className="flex justify-end mb-4">
                <Button
                  onClick={() => navigate(routes.createSubAgent(workspaceId))}
                  className="bg-[#6888E1] hover:bg-[#6888E1]/90 text-white"
                >
                  新規作成
                </Button>
              </div>
              <SubAgentsTable />
            </div>
          )}
        </div>
        <ScrollBar orientation="vertical" />
      </ScrollArea>
    </div>
  );
};

export default AgentManagementPage;
